import { getMessage } from '../../i18n/i18nWrapper';

export default function setup() {
  document.title = `${getMessage('login.title')}`;
  return Promise.resolve(true);
}